import React from 'react';
import { X, CheckCircle } from 'lucide-react';

const ThankYouModal = ({ isOpen, onClose, language }) => {
  if (!isOpen) return null;

  const messages = {
    en: {
      title: "Thank You!",
      message: "Your message has been sent successfully. We'll get back to you soon!",
      close: "Close"
    },
    it: {
      title: "Grazie!",
      message: "Il tuo messaggio è stato inviato con successo. Ti risponderemo presto!",
      close: "Chiudi"
    },
    es: {
      title: "¡Gracias!",
      message: "Tu mensaje ha sido enviado con éxito. ¡Te responderemos pronto!",
      close: "Cerrar"
    },
    fr: {
      title: "Merci!",
      message: "Votre message a été envoyé avec succès. Nous vous répondrons bientôt!",
      close: "Fermer"
    },
    de: {
      title: "Danke!",
      message: "Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns bald bei Ihnen melden!",
      close: "Schließen"
    }
  };

  const t = messages[language] || messages.en;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative transform animate-slideUp">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label={t.close}
        >
          <X className="w-6 h-6" />
        </button>

        {/* Success icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-4">
            <CheckCircle className="w-16 h-16 text-green-600" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            {t.title}
          </h3>
          <p className="text-gray-600 leading-relaxed mb-6">
            {t.message}
          </p>

          {/* Close button */}
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
          >
            {t.close}
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ThankYouModal;
